import { Map as map } from 'immutable';
const C = require("../constants");

function ModalProductIngredientsReducer(state = map(), action) {
    switch (action.type) {
        case C.OPEN_MODAL_PRODUCT_INGREDIENTS:
            return action.modal;
        default:
            return state;
    }
}

export default ModalProductIngredientsReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalProductIngredientsReducer.js